import { OrganizationCodes, CardLoginType, CARD_CODES, CardCodes } from '@revenuemarket/bank';
import { Flex } from '@revenuemarket/cds';
import { overlays } from '@revenuemarket/overlays';
import { Drawer, Typography } from 'antd';
import useGetCorporateCardConnections from '~hooks/queries/useCorporateCardConnections';
import { useCompanyId } from '~hooks/useCompanyId';

import { CardOrganizationConnectionDrawer } from './CardOrganizationConnectionDrawer';
import { CardOrganizationItem } from './CardOrganizationItem';

interface Props {
  isOpen: boolean;
  onClose: () => void;

  highlightedOrganization?: string;
  defaultActiveCardOrg?: OrganizationCodes;
  defaultLoginType?: CardLoginType;
}

export const CardConnectionDrawer: React.FC<Props> = ({
  isOpen,
  onClose,
  highlightedOrganization,
  defaultActiveCardOrg,
  defaultLoginType,
}) => {
  const { companyId } = useCompanyId();
  const { data: connectionData } = useGetCorporateCardConnections(companyId as string);
  const cardConnectionList = connectionData?.Data?.data?.connections || [];

  const getConnectionOrder = (code: string) => {
    const connections =
      cardConnectionList?.filter(
        (connection) => connection.organization.organizationCode === code && !connection.purgedAt,
      ) || [];

    if (connections.length === 0) return 2; // No connection - last
    if (connections.some((connection) => connection.status === 'DISCONNECTED')) return 0; // Has disconnected - first
    return 1; // Connected only - middle
  };

  const cardList = Object.keys(CARD_CODES).sort(
    (a, b) => getConnectionOrder(a) - getConnectionOrder(b),
  ) as OrganizationCodes[];

  return (
    <Drawer placement="right" title="카드사 연결" open={isOpen} onClose={onClose}>
      <div>
        <Flex
          direction="column"
          gap={24}
          style={{
            marginBottom: 24,
          }}
        >
          <Typography>이용하시는 카드사를 하나씩 클릭해 로그인을 진행해주세요.</Typography>
        </Flex>
        <Flex gap={12} direction="column">
          {cardList.map((code) => {
            const connections =
              cardConnectionList?.filter(
                (connection) =>
                  connection.organization.organizationCode ===
                    (code as unknown as OrganizationCodes) && !connection.purgedAt,
              ) || [];
            const connectionStatus =
              connections.length === 0
                ? undefined
                : connections.some((connection) => connection.status === 'DISCONNECTED')
                  ? 'DISCONNECTED'
                  : 'CONNECTED';
            return (
              <CardOrganizationItem
                key={code}
                organizationCode={code}
                organizationName={CARD_CODES[code as keyof typeof CARD_CODES]}
                connectionStatus={connectionStatus}
                onClick={() => {
                  overlays.open(({ isOpen, onClose }) => (
                    <CardOrganizationConnectionDrawer
                      organizationCode={code as CardCodes}
                      isOpen={isOpen}
                      onClose={onClose}
                    />
                  ));
                }}
                isHighlighted={highlightedOrganization === code}
              />
            );
          })}
        </Flex>
      </div>
    </Drawer>
  );
};
